<template>
    <div style="width: 100%;min-width: 600px;">
        <el-tabs v-model="activeTabName" @tab-click="handleClick" style="margin-left: 20px;margin-right: 20px;">
            <el-tab-pane label="详细信息" name="tab1" style="padding-top: 20px;padding-bottom: 20px;">

                <el-form size="mini" label-position="left"  class="demo-table-expand">
                    <el-collapse v-model="activeCollapseNames">
                        <el-collapse-item name="1">
                            <template slot="title">
                                <span class="tipTitle-collapse">基本信息</span>
                            </template>
                            <div>
                                <el-row :gutter="30">
                                    <el-col :span="12"><el-form-item label="ID：">{{inAgentInfo.id}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="编码：">{{inAgentInfo.agentCode}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="等级：">{{inAgentInfo.agentLevel.name}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="来源：">{{inAgentInfo.agentPidName}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="性质：">{{inAgentInfo.agentNature.name}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="名称：">{{inAgentInfo.agentName}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="简称：">{{inAgentInfo.shortName}}</el-form-item></el-col>
                                    <el-col :span="24"><el-form-item label="地址：">{{inAgentInfo.provIdName}} {{inAgentInfo.cityIdName}} {{inAgentInfo.distIdName}} {{inAgentInfo.addr}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="负责人：">{{inAgentInfo.linkMan}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="联系电话：">{{inAgentInfo.linkPhone}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="联系邮箱：">{{inAgentInfo.linkMail}}</el-form-item></el-col>
                                    <el-col :span="12" v-if="inAgentInfo.legalPerson"><el-form-item label="法人姓名：">{{inAgentInfo.legalPerson}}</el-form-item></el-col>
                                    <el-col :span="12" v-if="inAgentInfo.legalPhone"><el-form-item label="法人电话：">{{inAgentInfo.legalPhone}}</el-form-item></el-col>
                                    <el-col :span="12" v-if="inAgentInfo.legalIdcardNo"><el-form-item label="身份证号：">{{inAgentInfo.legalIdcardNo}}</el-form-item></el-col>
                                    <el-col :span="12" v-if="inAgentInfo.licenseCode"><el-form-item label="营业执照号：">{{inAgentInfo.licenseCode}}</el-form-item></el-col>
                                    <el-col :span="12" v-if="inAgentInfo.licensePhoto">
                                        <el-form-item label="营业执照图：">
                                            <el-image placeholder="营业执照图"
                                                      style="width: 100px; height: 100px"
                                                      :preview-src-list="[inAgentInfo.licensePhoto]"
                                                      :src="inAgentInfo.licensePhoto">
                                            </el-image>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-collapse-item>
                        <el-collapse-item name="2">
                            <template slot="title">
                                <span class="tipTitle-collapse">合同信息</span>
                            </template>
                            <div>
                                <el-row :gutter="5">
                                    <el-col :span="12"><el-form-item label="合同编号：">{{inAgentInfo.contractNo}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="合同时间：">{{inAgentInfo.contractBeg}} 至 {{inAgentInfo.contractEnd}}</el-form-item></el-col>
                                </el-row>
                                <el-row :gutter="5">
                                    <el-col :span="12"><el-form-item label="分润比例："><span style="font-weight:bold;font-size: 18px; color: red;">{{toPercent(inAgentInfo.contractReward)}}</span></el-form-item></el-col>

                                    <el-col :span="12" v-if="this.$store.state.currentHr.agentLevel===0 && inAgentInfo.agentStatusId===5 && showSendSms" >
                                        <el-form-item label="电签短信：">
                                        <el-tag type="success" effect="dark" class="cls-tag2btn" @click="viewSignMsg" style="margin-left: 5px; ">
                                            <i class="header-icon el-icon-message" /> 重发短信</el-tag>
                                        </el-form-item>
                                    </el-col>

                                </el-row>
                            </div>
                        </el-collapse-item>
                        <el-collapse-item name="3">
                            <template slot="title">
                                <span class="tipTitle-collapse">结算账户</span>
                            </template>
                            <div>
                                <el-row :gutter="5">
                                    <el-col :span="12"><el-form-item label="账户类型：">{{inAgentInfo.settleAccType.name}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="开户银行：">{{inAgentInfo.settleCnaps.cnapsName}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="开户名称：">{{inAgentInfo.stlAccName}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="银行卡号：">{{inAgentInfo.stlAccNo}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="开卡手机号：">{{inAgentInfo.stlAccPhone}}</el-form-item></el-col>
                                    <el-col :span="12"><el-form-item label="身份证号：">{{inAgentInfo.stlAccIdcardNo}}</el-form-item></el-col>
                                </el-row>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </el-form>

            </el-tab-pane>
            <el-tab-pane label="产品费率" name="tab2">
                <div style="margin-bottom: 20px">
                    <el-table :data="arch_userBaseProductRateInfo" v-loading="loading" size="mini" border ref="prodTable" >
                        <el-table-column label="产品名称" width="120" align="center">
                            <template slot-scope="scope">
                                <el-tag type="warning" effect="dark" style="height: 25px">
                                    <span style="font-size: 15px">{{scope.row.payProduct.productName}}</span>
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="结算价" prop="payProductChannelList" align="center">
                            <template slot-scope="scope">
                                <el-table :data="scope.row.payProductChannelList" type="expand" :show-header="false" >
                                    <el-table-column align="center" width="100" label="交易方式">
                                        <template slot-scope="scope">
                                            {{scope.row.payName}}
                                        </template>
                                    </el-table-column>

                                    <el-table-column label="费率" prop="userRateList" align="center">
                                        <template slot-scope="scope">
                                            <el-table :data="scope.row.userRateList" type="expand" :header-cell-style="{background:'#fafafa'}">
                                                <el-table-column label="费率类型" prop="rateTypeDesc" width="90" align="center"/>
                                                <el-table-column label="服务商费率（%）">
                                                    <template slot-scope="scope">
                                                        <span v-if="scope.row.rate===null">--</span>
                                                        <span v-else>{{scope.row.rate}}</span>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column label="单笔固定（元）" >
                                                    <template slot-scope="scope">
                                                        <span v-if="scope.row.fixRate===null">--</span>
                                                        <span v-else>{{scope.row.fixRate}}</span>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column label="单笔最低（元）">
                                                    <template slot-scope="scope">
                                                        <span v-if="scope.row.feeLowest===null">--</span>
                                                        <span v-else>{{scope.row.feeLowest}}</span>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column label="单笔封顶（元）">
                                                    <template slot-scope="scope">
                                                        <span v-if="scope.row.feeHighest===null">--</span>
                                                        <span v-else>{{scope.row.feeHighest}}</span>
                                                    </template>
                                                </el-table-column>

                                            </el-table>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <div class="tipTitle" style="display: flex; justify-content: left;">
                                    <!--
                                    <span style="font-weight:bold;font-size: 12px; color: red;">到账周期：{{scope.row.payProduct.settleCycle===1?'D0':'D1'}}</span>
                                    -->
                                    <span style="font-weight:normal;font-size: 12px; color: gray;">&nbsp;&nbsp;{{_enums.ProductChannelEnum.getDescById(scope.row.payProduct.productCode)}}</span>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>



                </div>
            </el-tab-pane>
            <el-tab-pane label="推荐记录" name="tab3">
                <div>
                    <el-table :data="fromAgents" v-loading="loading" size="mini">
                        <el-table-column type="index" label="序号" />
                        <el-table-column prop="agentCode" label="服务商编号" width="100px" />
                        <el-table-column prop="agentName" label="服务商名称" show-overflow-tooltip />
                        <el-table-column prop="agentLevel.name" label="等级" width="100px" />
                        <el-table-column prop="agentStatus.name" label="状态" width="100px" />
                    </el-table>
                </div>
                <!-- 分页栏 -->
                <div class="yx-flex-h-end">
                    <el-pagination small
                            @current-change="currentChangeFA"
                            @size-change="sizeChangeFA"
                            layout="total, prev, pager, next"
                            :total="total">
                    </el-pagination>
                </div>
            </el-tab-pane>
            <el-tab-pane label="系统账户" name="tab4">
                <div>
                    <el-table :data="sysLoginInfo" v-loading="loading" size="mini">
                        <el-table-column prop="name" label="账户名称" />
                        <el-table-column prop="username" label="登录账号" />
                        <el-table-column label="类别" width="100px" align="center">
                            <template slot-scope="scope">
                                <!--
                                <span v-if="scope.row.admin" style="color: blue">管理员</span>
                                <span v-else>客户经理</span>
                                -->
                                <span v-if="scope.row.type===2" style="color: blue">管理员</span>
                                <span v-else-if="scope.row.type===3">客户经理</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="状态" width="100px" align="center">
                            <template slot-scope="scope">
                                <el-tag type="success" v-if="scope.row.enabled" color="#FFFFFF">开启</el-tag>
                                <el-tag type="info" v-else color="#FFFFFF">关闭</el-tag>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <!-- 分页栏 -->
                <div class="yx-flex-h-end">
                    <el-pagination small
                                   @current-change="currentChangeSL"
                                   @size-change="sizeChangeSL"
                                   layout="total, prev, pager, next"
                                   :total="total">
                    </el-pagination>
                </div>
            </el-tab-pane>
            <el-tab-pane label="变更历史" name="tab5">
                <div>
                    <el-table :data="agentHis" v-loading="loading" size="mini">
                        <el-table-column type="expand">
                            <template slot-scope="props">
                                <el-form size="mini" label-position="left" class="demo-table-expand">
                                    <el-form-item label="账户类型">
                                        <span>{{ props.row.settleAccType.name }}</span>
                                    </el-form-item>
                                    <el-form-item label="开户银行">
                                        <span>{{ props.row.settleCnaps.cnapsName }}</span>
                                    </el-form-item>
                                    <el-form-item label="开户名称">
                                        <span>{{ props.row.stlAccName }}</span>
                                    </el-form-item>
                                    <el-form-item label="银行卡号">
                                        <span>{{ props.row.stlAccNo }}</span>
                                    </el-form-item>
                                </el-form>
                            </template>
                        </el-table-column>
                        <el-table-column type="index" label="序号" />
                        <el-table-column prop="updateTime" label="更新时间" />
                        <el-table-column prop="agentLevel.name" label="等级" width="100px" />
                        <el-table-column prop="agentStatus.name" label="状态" width="100px" />
                    </el-table>
                </div>
                <!-- 分页栏 -->
                <div class="yx-flex-h-end">
                    <el-pagination small
                                   @current-change="currentChangeAH"
                                   @size-change="sizeChangeAH"
                                   layout="total, prev, pager, next"
                                   :total="total">
                    </el-pagination>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
/*
    beforCreate（创建之前）
    Created（创建之后）
    beforMount（载入之前）
    Mounted（载入之后）
    beforUpdate（更新之前）
    Updated（更新之后）
    beforDestroy（销毁之前）
    Destroyed（销毁之后）
    activate（keep-alive组件激活时调用）
    deactivated（keep-alive组件停用时调用）
    errorCaptured（这个组件的作用是接受子孙组件报错是调用，三个参数 错误对象、错误的组件、错误信息）
*/


    import {URL_DATA_USER_BASE_PRORATE_BY_USER, URL_DATA_USER_BASE_PRORATE} from "../../utils/cons";
import {deepClone, toPercent} from "../../utils/datatool";

export default {
        name: "AgentDetailDiv",
        props:["inAgentInfo"],
        data() {
            return {
                showSendSms: true,
                firstOpen: true,
                activeCollapseNames:['1','2','3'],
                activeTabName: 'tab1',
                loading: false,
                total: 0,
                page: 1,
                size: 10,
                fromAgents:[],
                sysLoginInfo:[],
                agentHis:[],
                isEditTermRate: false,
                ysfTermRateArray: [],
                arch_userBaseProductRateInfo: [],
                myTermRate: []
            };
        },
        computed: {
            getMyTermRate() {
                return this.myTermRate;
            }
        },
        methods: {
            toPercent: toPercent,
            handleClick(tab, event) {
                switch (this.activeTabName) {
                    case "tab1":
                        break;
                    case "tab2":
                        this.initUserProdRate();
                        break;
                    case "tab3":
                        this.initFromAgents();
                        break;
                    case "tab4":
                        this.initSysLoginInfo();
                        break;
                    case "tab5":
                        this.initAgentHis();
                        break;
                }
            },
            sizeChangeFA(currentSize) {
                this.size = currentSize;
                this.initFromAgents();
            },
            currentChangeFA(currentPage) {
                this.page = currentPage;
                this.initFromAgents();
            },
            sizeChangeSL(currentSize) {
                this.size = currentSize;
                this.initSysLoginInfo();
            },
            currentChangeSL(currentPage) {
                this.page = currentPage;
                this.initSysLoginInfo();
            },
            sizeChangeAH(currentSize) {
                this.size = currentSize;
                this.initAgentHis();
            },
            currentChangeAH(currentPage) {
                this.page = currentPage;
                this.initAgentHis();
            },
            viewSignMsg() {
                this.$confirm('向商户【' + this.inAgentInfo.agentName + '】,手机号【' + this.inAgentInfo.linkPhone + '】重发签约短信？',
                    '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                    this.putRequest("/agent/signMsgSend?id=" + this.inAgentInfo.id).then(resp => {
                        if (resp) {
                            this.showSendSms = false
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            initSysLoginInfo() {
                this.loading = true;
                let url = '/agent/agentUsers?page=' + this.page + '&size=' + this.size;
                if (this.inAgentInfo.id) {
                    url += '&agentId=' + this.inAgentInfo.id;
                }
                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.sysLoginInfo = resp.data;
                        this.total = resp.total;
                    }
                })
            },
            initAgentHis() {
                this.loading = true;
                let url = '/agent/agentInfoHis?page=' + this.page + '&size=' + this.size;
                if (this.inAgentInfo.id) {
                    url += '&id=' + this.inAgentInfo.id;
                }
                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.agentHis = resp.data;
                        this.total = resp.total;
                    }
                })
            },
            initFromAgents() {
                this.loading = true;
                let url = '/agent/agentInfo?page=' + this.page + '&size=' + this.size;
                if (this.inAgentInfo.id) {
                    url += '&agentPid=' + this.inAgentInfo.id;
                }
                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.fromAgents = resp.data;
                        this.total = resp.total;
                    }
                })
            },
            async initUserProdRate() {
                this.isEditTermRate = false
                if (this.loading) return
                // 我的 用户基础产品费率档案
                this.myTermRate = [];
                this.loading = true;
                let resp1 = await this.getRequest(URL_DATA_USER_BASE_PRORATE) ////// 1.我的
                this.loading = false;
                if (resp1) {
                    resp1.data.forEach(item => {
                        if (item.templateRateList) { // 我的终端费率模板
                            this.myTermRate = deepClone(item.templateRateList)
                        }
                    })
                }
                // 传入服务商的 用户基础产品费率档案
                this.ysfTermRateArray = []; // 已勾选的终端费率模板
                this.arch_userBaseProductRateInfo = [];
                this.loading = true;
                let resp2 = await this.getRequest(URL_DATA_USER_BASE_PRORATE_BY_USER+'?userId=' + this.inAgentInfo.id + '&userType=1') ////// 1.代理商
                this.loading = false;
                if (resp2) {
                    resp2.data.forEach(item => {
                        if(item.status===1) this.arch_userBaseProductRateInfo.push(item); // 传入服务商的结算费率
                        if (item.templateRateList) { // 传入服务商的终端费率模板
                            item.templateRateList.forEach(item2 => {
                                let ret = this.myTermRate.filter(e => e.rate === item2.rate && e.userType === item2.userType)
                                if (ret.length>0) {
                                    this.ysfTermRateArray.push(item2.rate)
                                }
                            })
                        }
                    })
                }
            },
            async onEditOrSaveTermRate() {
                if (this.isEditTermRate) {
                    this.loading = true
                    let resp = await this.postRequest("/agent/updateTermTemplateRate", {
                        userId: this.inAgentInfo.id,
                        userType: 4, // 服务商的 终端 模板费率
                        ysfTermRateArray: this.ysfTermRateArray
                    })
                    this.loading = false
                    if (resp) {
                        this.isEditTermRate = !this.isEditTermRate
                    }
                } else {
                    this.isEditTermRate = !this.isEditTermRate
                }
            }
        }
    }
</script>

<style scoped>
</style>
